import { Component, Input } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';

@Component({
    selector: 'app-verification-heading',
    templateUrl: './verification-heading.component.html',
    styleUrls: ['./verification-heading.component.scss']
})
export class VerificationHeadingComponent {
  @Input() title: string;
  @Input() patientAttachment: PatientAttachment;

  constructor() {}
}
